import { useFeatureFlag } from '@moda/portal-stanchions';

export const useIsAffirmEnabled = () =>
  useFeatureFlag('affirm', [{ default: false }, { if: true, then: true }]);
